import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { LoginService } from "../../services/login.service";
import {emptyLogin, ILogin} from "../../model/login";
import { environment } from "../../../environments/environment";
import { emptyPerson, IPerson } from "../../model/person";

@Component({
  selector: 'app-pub-login',
  templateUrl: './pub-login.component.html',
  styleUrls: ['./pub-login.component.css']
})
export class PubLoginComponent implements OnInit, AfterViewInit {
  public devAuth: string;
  public nif: string;

  /**
   *
   * @type {boolean}
   */
  @Input() hideLogin: boolean;

  /**
   * Contenido del panel modal de nueva entidad
   */
  @ViewChild('loginOptions')
  private loginOptions: TemplateRef<any>;

  /**
   * Contenido del panel modal de nueva entidad
   */
  @ViewChild('direNotFoundOptions')
  private direNotFoundOptions: TemplateRef<any>;

  /**
   * Url de DIRe
   * @type {string}
   */
  direUrl = environment.direUrl;

  /**
   * Usuario logueado
   */
  person: IPerson = emptyPerson;

  /**
   * Usuario logueado
   */
  data: string = null;

  constructor(
    private modalService: NgbModal,
    private loginService: LoginService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    if (environment.devLogin) {
      this.loginService.loginDev().subscribe(res => {
        this.devAuth = res;
      });
    }
    this.person = this.loginService.getPerson();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      // En login con clave si no tiene DIRe se devuelve solo datos de usuario
      this.data = params['token'];
      if (this.data) {
        const login = emptyLogin;
        login.token = this.data;
        this.loginService.login(login);
        if (!this.loginService.isLogged()) {
          // Si no hay token redirigimos a si misma para quitar los datos de la uri
          // (con location.href porque con angular no podemos)
          location.href = '/portal';
        }
        this.person = this.loginService.getPerson();
        this.loginService.person$.subscribe(res => {
          this.nif = res.identifier;
          if (res.identifier && (!res.code && !res.authorizedOfInvoicingService)) {
            this.router.navigate([], {
              queryParams: {
                'token': null,
                'youCanRemoveMultiple': null,
              },
            }).then(() => {
              this.openDireNotFoundOptions();
            });
          }
        });
      }

    });
  }

  ngAfterViewInit() {
    if (this.loginService.openLoginModal) {
      this.openLoginOptions();
      this.loginService.openLoginModal = false;
    }else{
      // Para no levantar los 2 modales
      if (this.person && this.person.identifier &&
        (!this.person.code && !this.person.authorizedOfInvoicingService) && !this.data) {
        this.openDireNotFoundOptions();
      }
    }
  }

  /**
   * Abre el panel modal de DIRe no encontrado
   */
  openDireNotFoundOptions() {
    this.modalService.open(this.direNotFoundOptions).result
      .then(() => {
        this.loginService.logout();
      })
      .catch(() => {
        this.loginService.logout();
      });
  }

  /**
   * Abre el panel modal de login
   */
  openLoginOptions() {
    this.modalService.open(this.loginOptions).result
      .then(close => {
        if (close == 'cancel') {
          this.loginService.removeRedirectUrl();
        }
      })
      .catch(() => {
        this.loginService.removeRedirectUrl();
      });
  }

  /**
   * Ir a clientes o abrir modal si no esta logueado
   */
  redirectToCli() {
    this.loginService.setRedirectCliUrl();

    if (!this.loginService.isLogged()) {
      this.openLoginOptions();
    } else {
      this.loginService.redirectToUrl();
    }
  }

  /**
   * Ir a empresas o abrir modal si no esta logueado
   */
  redirectToInv() {
    this.loginService.setRedirectInvUrl();

    if (!this.loginService.isLogged()) {
      this.openLoginOptions();
    } else {
      this.loginService.redirectToUrl();
    }
  }

  /**
   * Metodo invocado al seleccionar el boton  de acceder con certificado
   */
  loginCert() {
    this.loginService.loginCert()
      .subscribe(login => {
        this.loginService.login$(login).subscribe( person => {
          let login = emptyLogin;
          login.person = person;
          this.loginService.setLoginData(login);
          this.loginService.redirectToUrl();
          this.person = this.loginService.getPerson();
          if (this.person && (!this.person.code && !this.person.authorizedOfInvoicingService)) {
            this.nif = this.person.identifier;
            this.openDireNotFoundOptions();
            this.loginService.removeToken();
          }
        });
      });
  }

  /**
   * Metodo invocado al seleccionar el boton  de acceder con clave
   */
  loginClave() {
    this.loginService.getClaveForm()
      .subscribe(loginForm => {
        const div = document.getElementById('clave');
        div.innerHTML = loginForm;
        const form = <HTMLFormElement>div.firstChild;
        form.submit();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/pub-login/pub-login.component.ts